'use strict';

var pump = require('pump');

var concat = require('concat-stream');
/*
  Concatenate a stream to a single value.
*/


function streamToValue(response, callback) {
  pump(response, concat(function (data) {
    return callback(null, data);
  }), function (err) {
    if (err) {
      callback(err);
    }
  });
}

module.exports = streamToValue;